import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { TemplatesState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: TemplatesState = {
    mnTemplates: null,
    mnMultichannelTemplates: [],
    mnServices: [],
    mnRoutesList: ['vk', 'ok', 'vk,ok'],
};


export const mnTemplate: Module<TemplatesState,RootState> = {
    state,
    getters,
    actions,
    mutations
};